import React, { FunctionComponent } from "react"
import classNames from "classnames"
import styles from "./sticky.module.scss"

export interface StickyProps {
  className?: string
  offsetTop?: number
  coverNav?: boolean
}

export const Sticky: FunctionComponent<StickyProps> = ({
  children,
  className,
  offsetTop,
  coverNav
}) => {
  const style = offsetTop ? { top: offsetTop } : {}

  return (
    <div
      className={classNames(styles.sticky, className, {
        [styles.coverNav]: coverNav
      })}
      style={style}
    >
      {children}
    </div>
  )
}
